module.exports = __webpack_public_path__ + "static/media/alert.31dc7cac.PNG";